import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FeedbackService } from '../services/feedback.service';
import { Globals } from '../globals';
declare function myInput(): any;
declare var $, unescape, escape: any;

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {

  RegisterEntity;
  btn_disable;
  submitted;
  UserId;
  rater;
  mutirater;
  step1;
  step2;

  constructor(public globals: Globals, private FeedbackService: FeedbackService, private router: Router) { }

  ngOnInit() {
    this.step1 = true;
    this.step2 = false;
    this.rater = false;
    this.mutirater = false;
    localStorage.removeItem('UserId');
    localStorage.removeItem('ParentId');
    localStorage.removeItem('FirstName');
    localStorage.removeItem('LastName');
    localStorage.removeItem('MaltiRater');
    localStorage.removeItem('rate1');
    localStorage.removeItem('rate2');
    localStorage.removeItem('rate3');
    localStorage.removeItem('rate4');
    localStorage.removeItem('rate5');
    localStorage.removeItem('rate6');
    localStorage.removeItem('rate7');
    localStorage.removeItem('rate8');
    localStorage.removeItem('rate9');
    localStorage.removeItem('Delivering');
    localStorage.removeItem('Receiving');

    var currentYear = (new Date()).getFullYear();
    $("#footer_year").html(currentYear);

    const body = document.querySelector('body');
    body.style.setProperty('--screen-height', $(window).height() - 40 + "px");

    this.UserId = localStorage.getItem('UserId');
    if (this.UserId > 0) {
      //this.router.navigate(['/feedback']);
      window.location.href = '/feedback';
    } else {
      this.globals.pageTitle = '- Registration';
      this.RegisterEntity = {};
      $('body').addClass('height_100');
      setTimeout(function () {
        myInput();
      }, 100);

    }
    $('body').tooltip({
      selector: '[data-toggle="tooltip"], [title]:not([data-toggle="popover"])',
      trigger: 'hover',
      container: 'body'
    }).on('click mousedown mouseup', '[data-toggle="tooltip"], [title]:not([data-toggle="popover"])', function () {
      $('[data-toggle="tooltip"], [title]:not([data-toggle="popover"])').tooltip('destroy');
    });

    checkCookie_eu();

    function checkCookie_eu() {

      var consent = getCookie_eu("cookies_consent");

      if (consent == null || consent == "" || consent == undefined) {
        // show notification bar
        $('#cookie_directive_container').show();
      }

    }

    function setCookie_eu(c_name, value, exdays) {

      var exdate = new Date();
      exdate.setDate(exdate.getDate() + exdays);
      var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
      document.cookie = c_name + "=" + c_value + "; path=/";

      $('#cookie_directive_container').hide();
    }


    function getCookie_eu(c_name) {
      var i, x, y, ARRcookies = document.cookie.split(";");
      for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
          return unescape(y);
        }
      }
    }


  }
  close_cookie() {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + 30);
    var c_value = escape(1) + ((30 == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = "cookies_consent =" + c_value + "; path=/";

    $('#cookie_directive_container').hide();
  }
  Register(RegisterForm) {
    this.submitted = true;
    if (RegisterForm.valid) {
      this.btn_disable = true;

      this.rater = true;

      // this.globals.isLoading = true;
      // this.RegisterEntity.IsActive=1;
      // if(this.RegisterEntity.FirstName && this.RegisterEntity.FirstName!=''){
      //   localStorage.setItem('FirstName',this.RegisterEntity.FirstName);
      // } else {
      //   localStorage.setItem('FirstName','Anonymous');
      // }    	  
      // this.FeedbackService.Register(this.RegisterEntity)
      // .then((data) => 
      // {		
      //   this.UserId = data;	        
      //   this.globals.isLoading = false;
      //   this.btn_disable = false;
      //   this.submitted = false;
      //   this.RegisterEntity = {};
      //   RegisterForm.form.markAsPristine(); 
      //   localStorage.setItem('UserId',this.UserId);	
      //   //this.router.navigate(['/feedback']);
      //   window.location.href = '/feedback';
      // }, 
      // (error) => 
      // { 
      //   this.btn_disable = false;
      //   this.submitted = false;
      //   this.globals.isLoading = false;
      //   this.router.navigate(['/pagenotfound']);
      // });
    }
  }

  semiRegister(rater) {
    if (rater == 0) {
      this.RegisterEntity.MaltiRater=0;
    } else if (rater == 1) {
      this.RegisterEntity.MaltiRater=1;
    }
    localStorage.setItem('MaltiRater', this.RegisterEntity.MaltiRater);
    this.globals.isLoading = true;
    this.FeedbackService.Register(this.RegisterEntity)
      .then((data) => {
        this.UserId = data;
        this.globals.isLoading = false;
        this.btn_disable = false;
        this.submitted = false;        
        //RegisterForm.form.markAsPristine(); 
        localStorage.setItem('UserId', this.UserId);
        localStorage.setItem('ParentId', '0');
        window.location.href = '/feedback';
      },
        (error) => {
          this.btn_disable = false;
          this.submitted = false;
          this.globals.isLoading = false;
          this.router.navigate(['/pagenotfound']);
        });
  }

  finalRegister(RegisterForm) { debugger
    this.submitted = true;
    if(RegisterForm.valid){
      this.submitted = false;
      this.btn_disable = true;
    
    this.RegisterEntity.IsActive = 1;
    // this.RegisterEntity.MaltiRater = rater;
    // localStorage.setItem('MaltiRater', rater);
    localStorage.setItem('SelectedName', name);
    if (this.RegisterEntity.FirstName && this.RegisterEntity.FirstName != '') {
      localStorage.setItem('FirstName', this.RegisterEntity.FirstName);
    } else {
      localStorage.setItem('FirstName', 'Anonymous');
    }
    if (this.RegisterEntity.LastName && this.RegisterEntity.LastName != '') {
      localStorage.setItem('LastName', this.RegisterEntity.LastName);
    } else {
      localStorage.setItem('LastName', 'Anonymous');
    }

    this.step1 = false;
    this.step2 = true;

  }
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/OESS_LFB_V2demo/src/app/registration/registration.component.ts